export default function leadingZero(num) {
  return num < 10 ? `0${num}` : num.toString();
}
